"use client";
import Image from "next/image";
import { Heading } from "../design-system/atoms/Heading";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Link from "next/link";

type StrapiMedia = {
  url?: string;
  alternativeText?: string;
};

type PdfFile = {
  url?: string;
};

type CardPdf = {
  id: number | string;
  titre?: string;
  sousTitre?: string;
  isPublish?: boolean;
  pdf?: PdfFile[];
  cover?: StrapiMedia;
};

type RessourcesData = {
  id?: number | string;
  documentId?: string;
  titre?: string;
  description?: string;
  image?: StrapiMedia;
  cardsPDF?: CardPdf[];
};


export default function Ressources({ data }: { data: RessourcesData  }) {
  if (!data) return null;
  const publishedPDFs = (data.cardsPDF || []).filter(
  (item) => item.isPublish && item.pdf && item.pdf.length > 0
);
  const imageUrl = data.image?.url || "";
  const imageAlt = data.image?.alternativeText || "";
  return (
    <section className="w-full overflow-x-hidden relative">
      {/* 🟩 Bande verte */}
      <div className="lms-container">
        <Image
          src={imageUrl}
          alt={imageAlt}
          /* width={1920}
            height={651} */
          fill={true}
          style={{
            objectFit: "cover",
          }}
        />
        <div
          className="h-[450px] lg:h-[600px] relative bg-primaryGreen text-white py-20 px-6 lg:px-16 text-center lg:text-left flex flex-col lg:flex-row justify-between items-center gap-8"
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="max-w-3xl">
            <Heading
              as="h2"
              className="text-4xl lg:text-[44px] font-bold leading-tight mb-4"
            >
              {data.titre}
            </Heading>
            <p className="text-lg leading-relaxed text-white/90">
              {data.description}
            </p>
          </div>
        </div>

        {/* Carrousel PDF */}
        <div className="relative bg-white py-8 px-6 md:px-10 -mt-28 rounded-t-3xl shadow-sm">
          <Swiper
            modules={[Navigation]}
            navigation
            loop={true}
            slidesPerView={3}
            spaceBetween={40}
            grabCursor={true}
            centeredSlides={false} // 🔹 Important : permet 3 visibles dès le début
            initialSlide={0} // 🔹 Démarre au premier PDF
            className="max-w-[1300px] mx-auto "
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 20 },
              768: { slidesPerView: 2, spaceBetween: 30 },
              1024: { slidesPerView: 3, spaceBetween: 40 },
            }}
          >
            {publishedPDFs.map((item) => (
              <SwiperSlide key={item.id} className="flex justify-center h-full">
                <Link
                  href={item.pdf?.[0]?.url || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
                  group relative block bg-white text-center rounded-2xl p-6
                  transition-all duration-300 border-2 border-transparent
                  cursor-pointer max-w-[320px]  overflow-visible
                "
                >
                  {/* 🖼️ Miniature */}
                  <div className="relative w-full h-[300px] mb-6 overflow-visible">
                    <Image
                      src={item.cover?.url || "/fallback-image.jpg"}
                      alt={item.cover?.alternativeText || item.titre || ""}
                      width={280}
                      height={334}
                    />
                  </div>

                  {/* 📘 Titre */}
                  <h3 className="text-xl font-bold text-primaryGreen mb-2">
                    {item.titre}
                  </h3>

                  {/* 📄 Sous-titre */}
                  <p className="text-gray-700 text-base leading-snug">
                    {item.sousTitre}
                  </p>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

    </section>
  );
}
